import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const setupPaymentMethodRoutes = {
  name: 'payment-method-management',
  path: 'setup/payment-method-management',
  component: () => import('./SetupPaymentMethod.vue'),
  meta: { i18n },
} satisfies RouteRecordRaw;
